import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const PromisingBetInfo = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    paddingBottom: defaultTheme.spacing.l,
  }),
);

export const SetNumberArea = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '140px',
    p: {
      fontSize: defaultTheme.font.size.xs,
      lineHeight: defaultTheme.font.height.base,
      color: defaultTheme.color.grayScale.dark,
      marginBottom: defaultTheme.spacing.s,
    },
  }),
);

export const DetailWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    marginTop: defaultTheme.spacing.l,
  }),
);

export const Detail = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.m,
    marginBottom: defaultTheme.spacing.l,
    p: {
      fontSize: defaultTheme.font.size.xs,
      lineHeight: defaultTheme.font.height.base,
      color: defaultTheme.color.grayScale.dark,
    },
    span: {
      display: 'inline-block',
      textAlign: 'right',
    },
  }),
);
